import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';

interface CancellationModalProps {
    appointmentId: number;
    onClose: () => void;
    onSuccess: () => void;
}

const CancellationModal: React.FC<CancellationModalProps> = ({ appointmentId, onClose, onSuccess }) => {
    const [step, setStep] = useState<'confirm' | 'code'>('confirm');
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const requestCancellation = async () => {
        setLoading(true);
        try {
            await axios.post(`${API_BASE_URL}/api/public/appointments/cancel/`, {
                appointment_id: appointmentId,
                action: 'request_code'
            });
            setStep('code');
            setMessage('Código de cancelamento enviado para seu WhatsApp.');
        } catch (err) {
            console.error(err);
            setMessage('Erro ao solicitar cancelamento.');
        } finally {
            setLoading(false);
        }
    };

    const confirmCancellation = async () => {
        setLoading(true);
        try {
            await axios.post(`${API_BASE_URL}/api/public/appointments/cancel/`, {
                appointment_id: appointmentId,
                action: 'confirm',
                code
            });
            onSuccess();
            onClose();
        } catch (err) {
            console.error(err);
            setMessage('Código inválido.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
            <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', maxWidth: '400px', width: '90%' }}>
                <h3>Cancelar Agendamento</h3>

                {step === 'confirm' && (
                    <>
                        <p>Tem certeza que deseja cancelar este agendamento? Enviaremos um código para seu WhatsApp para confirmar.</p>
                        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                            <button onClick={onClose} style={{ flex: 1, padding: '0.5rem', background: '#ccc', border: 'none', borderRadius: '4px' }}>Voltar</button>
                            <button onClick={requestCancellation} disabled={loading} style={{ flex: 1, padding: '0.5rem', background: '#dc3545', color: 'white', border: 'none', borderRadius: '4px' }}>
                                {loading ? 'Enviando...' : 'Solicitar Código'}
                            </button>
                        </div>
                    </>
                )}

                {step === 'code' && (
                    <>
                        <p>{message}</p>
                        <div className="form-group">
                            <label>Código de Confirmação</label>
                            <input type="text" value={code} onChange={e => setCode(e.target.value)} placeholder="Insira o código" className="form-control" />
                        </div>
                        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', flexDirection: 'column' }}>
                            <button onClick={confirmCancellation} disabled={loading} style={{ width: '100%', padding: '0.75rem', background: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', fontWeight: 'bold' }}>
                                {loading ? 'Confirmando...' : 'Confirmar Cancelamento'}
                            </button>

                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <button
                                    onClick={requestCancellation}
                                    disabled={loading}
                                    style={{ flex: 1, padding: '0.5rem', background: 'transparent', border: '1px solid #ccc', borderRadius: '4px', color: '#666' }}
                                >
                                    Reenviar Código
                                </button>
                                <button
                                    onClick={onClose}
                                    style={{ flex: 1, padding: '0.5rem', background: '#eee', border: 'none', borderRadius: '4px', color: '#333' }}
                                >
                                    Fechar/Desistir
                                </button>
                            </div>
                        </div>
                    </>
                )}

                {message && step === 'confirm' && <p style={{ color: 'red', marginTop: '1rem' }}>{message}</p>}
            </div>
        </div>
    );
};

export default CancellationModal;
